module.exports = __webpack_public_path__ + "static/media/invite_user.c9f8ae99.png";